import { useReducer, useCallback } from 'react';
import { selectionReducer, INITIAL_SELECTION_STATE } from './selection-reducer';
import type { MediaUnitId } from './selection-reducer';

export interface AreaSelectionActions {
  toggleOne: (id: MediaUnitId) => void;
  addMany: (ids: readonly MediaUnitId[]) => void;
  removeMany: (ids: readonly MediaUnitId[]) => void;
  clear: () => void;
  replace: (ids: readonly MediaUnitId[]) => void;
}

export interface UseAreaSelectionResult {
  selectedIds: ReadonlySet<MediaUnitId>;
  isEmpty: boolean;
  count: number;
  actions: AreaSelectionActions;
}

export function useAreaSelection(): UseAreaSelectionResult {
  const [state, dispatch] = useReducer(selectionReducer, INITIAL_SELECTION_STATE);

  const toggleOne = useCallback((id: MediaUnitId) => dispatch({ type: 'TOGGLE_ONE', id }), []);
  const addMany = useCallback(
    (ids: readonly MediaUnitId[]) => dispatch({ type: 'ADD_MANY', ids }),
    [],
  );
  const removeMany = useCallback(
    (ids: readonly MediaUnitId[]) => dispatch({ type: 'REMOVE_MANY', ids }),
    [],
  );
  const clear = useCallback(() => dispatch({ type: 'CLEAR' }), []);
  const replace = useCallback(
    (ids: readonly MediaUnitId[]) => dispatch({ type: 'REPLACE', ids }),
    [],
  );

  return {
    selectedIds: state.selectedIds,
    isEmpty: state.selectedIds.size === 0,
    count: state.selectedIds.size,
    actions: { toggleOne, addMany, removeMany, clear, replace },
  };
}
